import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

interface Props {
  handleUsageStatsDownload: (timeSpan: number) => Promise<void>;
  sendUsageStatsCSVEmail: (timeSpan: number) => Promise<void>;
}

function UsageStatsModal(props: Props) {
  const { handleUsageStatsDownload, sendUsageStatsCSVEmail } = props;
  const [downloadTimeSpan, setDownloadTimeSpan] = useState(0);
  return (
    <div id='usagestatsmodal-wrapper' className="flex flex-col gap-2 mb-2">
      <span id='usagestatsmodal-message' >
        This report helps Formulatrix understand your usage patterns. It includes all
        features accessed by each user.
      </span>
      <div id='usagestatsmodal-content'>
        <label id='usagestatsmodal-label' htmlFor="timespan" className="mr-2">
          Select a date range:
        </label>
        <select
          id="usagestatsmodal-select-timespan"
          onChange={(e) => setDownloadTimeSpan(parseInt(e.target.value))}
        >
          <option id={`usagestatsmodal-option-0`} value="0" selected>
            All
          </option>
          <option id={`usagestatsmodal-option-7`} value="-7">Last 7 days</option>
          <option id={`usagestatsmodal-option-30`} value="-30">Last 30 days</option>
          <option id={`usagestatsmodal-option-365`}value="-365">Last year</option>
        </select>
      </div>
      <div id="usagestatsmodal-button-wrapper" >
        <Button id="usagestatsmodal-downloadcsv-button" onClick={() => handleUsageStatsDownload(downloadTimeSpan)}>
          Download CSV
        </Button>
        <Button
          id="usagestatsmodal-sendviaemail-button"
          variant="secondary"
          style={{ marginLeft: '10px' }}
          onClick={() => sendUsageStatsCSVEmail(downloadTimeSpan)}
        >
          Send via Email
        </Button>
      </div>
    </div>
  );
}

export default UsageStatsModal;
